module.exports = __webpack_public_path__ + "static/timstripy-7a53dd942029504814ad2fdf30cf4950.jpg";